import styled from "@emotion/styled";
import { Checkbox, CheckboxProps, IconButton } from "@mui/material";
import AddIcons from "../resources/images/icons-add.svg";
import CheckIcons from "../resources/images/icons-check.svg";

type CustomCheckboxProps = CheckboxProps;

const CustomCheckbox = ({ checkedIcon, icon, ...props }: CustomCheckboxProps) => {
  return (
    <>
      <Checkbox
        {...props}
        checkedIcon={
          <IconButtonStyled size='small'>
            <CheckIcons className='success' />
          </IconButtonStyled>
        }
        icon={
          <IconButtonStyled size='small'>
            <AddIcons className='add' />
          </IconButtonStyled>
        }
        sx={{
          "&.MuiCheckbox-root:hover": {
            backgroundColor: "transparent !important"
          }
        }}
      />
    </>
  );
};

export default CustomCheckbox;

const IconButtonStyled = styled(IconButton)`
  width: 2rem;
  height: 2rem;

  svg.success path[fill="#111827"] {
    fill: #4caf50;
  }

  svg.add path[fill="#111827"] {
    fill: #4d5ef7;
  }
`;
